import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { months } from "../../../config/pillveryVariables";

export default function TotalRevenueChart() {
  const { statistics, loading } = useSelector((state) => state.Dashboard);

  const chartRef = useRef();

  useEffect(() => {
    if (chartRef && chartRef.current) {
      var onlineRevenueCanvas = chartRef?.current?.getContext("2d");

      var gradient1 = onlineRevenueCanvas.createLinearGradient(0, 0, 0, 300);
      gradient1.addColorStop(0, "rgba(5, 541, 186, .2)");
      gradient1.addColorStop(1, "rgba(255,255,255,.2)");
      var gradient2 = onlineRevenueCanvas.createLinearGradient(0, 0, 0, 500);
      gradient2.addColorStop(0, "#dcd7ff");
      gradient2.addColorStop(1, "rgba(255,255,255,0)");
      const maxRevenue = Math.max(
        ...(statistics?.revenuePerMonth?.revenue_by_date?.map(
          (item) => item["total"]
        ) || [0])
      );

      var data = {
        labels: statistics?.revenuePerMonth?.revenue_by_date?.map((item) => {
          const monthName = months[item["_id"]["month"] - 1 || 0];
          return (
            item["_id"]["day"] + " " + monthName + " " + item["_id"]["year"]
          );
        }),
        datasets: [
          // {
          //     label: 'Offline Revenue',
          //     data: [600, 620, 530, 610 , 540, 770, 700, 800],
          //     borderColor: [
          //         '#00dac5'
          //     ],
          //     borderWidth: 4,
          //     fill: true,
          //     backgroundColor: gradient1
          // },
          {
            label: "Online Revenue",
            data: statistics?.revenuePerMonth?.revenue_by_date?.map((item) => {
              return item["total"];
            }),
            borderColor: ["#6201ed"],
            borderWidth: 4,
            fill: true,
            backgroundColor: gradient2,
          },
        ],
      };
      var options = {
        scales: {
          yAxes: [
            {
              display: true,
              gridLines: {
                drawBorder: false,
                lineWidth: 1,
                color: "#f1f3f9",
                zeroLineColor: "#f1f3f9",
              },
              ticks: {
                min: 0,
                max:
                  maxRevenue > 1000
                    ? parseInt(maxRevenue / 100) * 100 + 200
                    : 1000,
                stepSize: 200,
                fontColor: "#979797",
                fontSize: 11,
                fontStyle: 400,
                padding: 15,
              },
            },
          ],
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false,
                drawBorder: false,
                lineWidth: 1,
                color: "#e9e9e9",
              },
              ticks: {
                fontColor: "#979797",
                fontSize: 11,
                fontStyle: 400,
                padding: 15,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        legendCallback: function (chart) {
          var text = [];
          text.push('<div class="d-flex align-items-center">');
          text.push('<small class="text-muted">Online revenue</small>');
          text.push(
            '<div class="ml-3" style="width: 12px; height: 12px; background-color: ' +
              chart.data.datasets[0].borderColor[0] +
              ' "></div>'
          );
          text.push("</div>");
          // text.push('<div class="d-flex align-items-center mt-2">');
          // text.push('<small class="text-muted">Offline revenue</small>');
          // text.push('<div class="ml-3" style="width: 12px; height: 12px; background-color: ' + chart.data.datasets[1].borderColor[0] +' "></div>');
          // text.push('</div>');
          return text.join("");
        },
        elements: {
          point: {
            radius: 2,
          },
          line: {
            tension: 0.35,
          },
        },
        stepsize: 1,
        layout: {
          padding: {
            top: 30,
            bottom: 0,
            left: 0,
            right: 0,
          },
        },
      };
      var onlineRevenue = new window.Chart(onlineRevenueCanvas, {
        type: "line",
        data: data,
        options: options,
      });
      // document.getElementById('online-revenue-legend').innerHTML = onlineRevenue.generateLegend();
    }
  }, [statistics]);

  return (
    <>
      <canvas ref={chartRef}></canvas>
    </>
  );
}
